<script setup>

import { defineProps, defineEmits, ref, computed, watch} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import DadoConteudo from "./DadoConteudo.vue";
import ERP from "@apiV2/ERP.mjs";
import View from "@apiV2/View.mjs";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "dado",
    "preenchendoDadoGestor",
    "controlesDesativados",
]);

const emits = defineEmits([
    "update:alteraDado",
    "update:alteraControlesDesativados",
    "update:alteraPreenchendoDadoGestor",
]);

//==================================================================//
//================= Coordenadores de Contratos =====================//
//==================================================================//

const coordenadoresDeContratos = ref([]);

//==================================================================//
//============== Loaded Coordenadores de Contratos =================//
//==================================================================//

const loadedCoordenadoresDeContratos = ref([]);

//==================================================================//
//=============== Altera Controles Desattivados ====================//
//==================================================================//

const alteraControlesDesativados = (update) =>{

    emits('update:alteraControlesDesativados',update);

};

//==================================================================//
//============== Altera Preenchendo Dado Gestor ====================//
//==================================================================//

const alteraPreenchendoDadoGestor = (update) =>{

    emits('update:alteraPreenchendoDadoGestor',update);

};

//==================================================================//
//==================== Altera Dado de Compra =======================//
//==================================================================//

const alteraDado = (update)=>{

    emits('update:alteraDado',{
        ...props.dado,
        ...update
    });

};

//==================================================================//
//========================= Mosta Modal ============================//
//==================================================================//

const mostraModal = computed(()=>{

    // Se a Modal não está Permitido Abrir.
    if(props?.preenchendoDadoGestor == false){
        return false;
    }

    // Se os Coordenadores de Contratos ainda não foram carregados.
    if(loadedCoordenadoresDeContratos.value == false){
        return false;
    }

    return true;

});

//==================================================================//
//=============== Altera Coordenadores de Contratos ================//
//==================================================================//

const alteraCoordenadoresDeContratos = (update = [])=>{

    coordenadoresDeContratos.value = update

};

//==================================================================//
//============ Altera Loaded Coordenadores de Contratos ============//
//==================================================================//

async function alteraLoadedCoordenadoresDeContratos(update = false) {

    loadedCoordenadoresDeContratos.value = update;

}

//==================================================================//
//=============== Load Coordenadores de Contratos ==================//
//==================================================================//

const loadCoordenadoresDeContratos = async ()=>{

    const coordenadoresDeContratosResponse = await ERP.getManyWithView(View.JOB_COORDENADORES_DE_CONTRATOS);

    alteraCoordenadoresDeContratos(coordenadoresDeContratosResponse.data);

    alteraLoadedCoordenadoresDeContratos(true);

};

//==================================================================//
//================ Altera Coordenador de Contrato ==================//
//==================================================================//

const alteraCoordenadorDeContrato = (update) =>{

    alteraDado({
        coordenadorDeContratos: update.coordenadorDeContratos || {}
    });

}

//==================================================================//
//======================== Prepara Modal ===========================//
//==================================================================//

const preparaModal = async ()=>{

    await loadCoordenadoresDeContratos();

}

//====================================================================//
//==== Prepara Modal se Dados Originais Carregados ou Recarregados ===//
//================ Watch => preenchendoDadoGestor ====================//
//====================================================================//

watch(()=> props?.preenchendoDadoGestor, async() => {

    if(props?.preenchendoDadoGestor == true){
        await preparaModal();
    }

},{ immediate: true });

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="mostraModal"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card class="c-modal">

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :dado="props.dado"
                    :preenchendoDadoGestor="props.preenchendoDadoGestor"
                    :controlesDesativados="props.controlesDesativados"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraPreenchendoDadoGestor="alteraPreenchendoDadoGestor"
                ></BarraNavegacao>

                <DadoConteudo
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :dado="props.dado"
                    :preenchendoDadoGestor="props.preenchendoDadoGestor"
                    :coordenadoresDeContratos="coordenadoresDeContratos"
                    @update:alteraCoordenadorDeContrato="alteraCoordenadorDeContrato"
                ></DadoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

</style>